import { CommonStyles } from '~src/commonInfra/styles/CommonStyles';

import { cssClass } from '../../style';

export namespace SharedViewsPopupStyle {

  export const sharedViewsPopupCssPrefix = 'SharedViewsPopup';

  export const SpinnerContainer = cssClass(sharedViewsPopupCssPrefix, 'container-spinner', {
    margin: '16px',
  });

  export const ContentContainer = cssClass(sharedViewsPopupCssPrefix, 'container-content', {
    lineHeight: '1.5em',
    maxHeight: '300px',
    overflowY: 'scroll',
    padding: '16px 0px',
    width: '320px',
    $nest: {
      '> p': {
        margin: '0px 16px',
      },
    }
  });

  export const Title = cssClass(sharedViewsPopupCssPrefix, 'title', {
    color: '#333333',
    fontSize: '16px',
    fontWeight: 'normal',
    margin: '0px 16px 24px 16px',
  });

  export const SharedViewsList = cssClass(sharedViewsPopupCssPrefix, 'shared-views-list', {
    marginTop: '12px',
    wordBreak: 'break-word',
  });

  export const SharedViewContainer = cssClass(sharedViewsPopupCssPrefix, 'shared-view-container', {
    display: 'flex',
    padding: '12px 16px',
    $nest: {
      '&:hover': {
        backgroundColor: '#F5F5F5',
      },
    }
  });

  export const SharedViewDetails = cssClass(sharedViewsPopupCssPrefix, 'shared-view-details', {
    flexDirection: 'column',
  });

  export const SharerName = cssClass(sharedViewsPopupCssPrefix, 'sharer-name', {
    fontWeight: 'bold',
  });

  export const SharedAt = cssClass(sharedViewsPopupCssPrefix, 'shared-at', {
    color: CommonStyles.Colors.Grey102,
  });

  export const Message = cssClass(sharedViewsPopupCssPrefix, 'message', {
    marginTop: '16px',
  });

  export const ViewLink = cssClass(sharedViewsPopupCssPrefix, 'view-link', {
    marginTop: '10px',
    $nest: {
      'a': {
        textDecoration: 'underline',
      },
      'a:hover': {
        textDecoration: 'none',
      },
    }
  });
}
